import { render } from "./ListChat.vue?vue&type=template&id=4cd47158"
import script from "./ListChat.vue?vue&type=script&lang=js"
export * from "./ListChat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__